import React, { useContext } from 'react';
import { Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FamilyContext } from '../Context/FamilyHeadContext';
import familyData from '../data/hebrewFamilyHeadStyles.json';
import {useTranslation} from "react-i18next";
import {formatNameAncestor} from "../utils/personUtils";

const About = () => {
    const { currentFamilyHead, pathPrefix } = useContext(FamilyContext);
    const {t, i18n} = useTranslation()

    const getAboutContent = () => {
        if (!currentFamilyHead?.nickname) return [];

        const aboutText = familyData[currentFamilyHead.nickname]?.popupText;

        if (Array.isArray(aboutText)) {
            return aboutText;
        }

        return [
            `אודות משפחת ${formatNameAncestor(currentFamilyHead, i18n["language"])}`,
            'מידע נוסף על המשפחה יתווסף בקרוב.'
        ];
    };

    return (
        <div className="min-h-screen bg-[#f8f5f1] py-12 px-4">
            <div className="max-w-4xl mx-auto space-y-12">
                {/* חלק עליון - אודות */}
                <section className="bg-white rounded-2xl p-8 shadow-[0_4px_20px_rgba(201,166,108,0.08)]">
                    <h1 className="text-3xl font-heebo font-bold text-[#937c5d] mb-8
                                relative pb-3 after:content-[''] after:absolute after:-bottom-1
                                after:right-0 after:h-[2px] after:w-24
                                after:bg-gradient-to-l after:from-[#937c5d] after:to-[#c9a66c]">
                        {t('contact.about')} {formatNameAncestor(currentFamilyHead, i18n["language"])}
                    </h1>

                    <div className="space-y-4 text-lg text-[#4a3f30] leading-relaxed">
                        {getAboutContent().map((paragraph, index) => (
                            <p key={index} className="font-heebo">
                                {paragraph}
                            </p>
                        ))}
                    </div>
                </section>

                {/* חלק תחתון - יצירת קשר */}
                <section className="bg-white rounded-2xl p-8 shadow-[0_4px_20px_rgba(201,166,108,0.08)]">
                    <h2 className="text-2xl font-heebo font-bold text-[#937c5d] mb-6">
                        {t('contact.title')}
                    </h2>
                    <div className="group block bg-[#f8f5f1] rounded-xl p-6 transition-all duration-300
               hover:shadow-md hover:-translate-y-0.5">
                        <div className="flex items-center gap-4">
                            <div className="w-12 h-12 rounded-full bg-[#937c5d]/10
                         flex items-center justify-center
                         transition-colors">
                                <Mail className="w-6 h-6 text-[#937c5d]" />
                            </div>
                            <div>
                                <h3 className="font-heebo font-bold text-[#4a3f30] mb-1">
                                    {t('contact.emailAddress')}
                                </h3>
                                <p className="font-heebo text-[#937c5d] cursor-pointer hover:underline
                  hover:text-[#4a3f30] transition-colors duration-300"
                                   onClick={() => window.open(`https://mail.google.com/mail/u/0/?fs=1&to=harel@bazach.com&su=&tf=cm`, '_blank')}>
                                    harel@bazach.com
                                </p>
                                <Link to={`${pathPrefix}person/@I00941@`} className="font-heebo text-[#4a3f30] mt-1">{t('contact.addressDetails')}</Link>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default About;